import { createTheme} from '@material-ui/core/styles';
import { grey } from '@material-ui/core/colors';

export const customInputTheme = createTheme({
  palette: {
    primary: grey,
  },
});